import React from "react";
import SharedLayout from "./SharedLayout";
import "./PricingView.css";
import "../styles/PageWrappers.css";

const PricingView = ({ user, onLoginClick }) => {
  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div className="pricing-wrapper">
        <h1>Pricing and Delivery</h1>

        <div className="pricing-container">
          {/* Biometrics Card */}
          <div className="pricing-card">
            <div className="pricing-header">
              <h2>Sigmund</h2>
              <h3>Biometrics with custom DNA/SNPs panel</h3>
            </div>
            <div className="pricing-price">
              <span className="currency">$</span>
              <span className="amount">1,599</span>
              <span className="period">One time</span>
            </div>
            <div className="pricing-features">
              <h4>Includes</h4>
              <ul>
                <li>Calibrated Biometric Questionnaire</li>
                <li>DNA/SNPs Panel</li>
                <li>Emotional State Report</li>
              </ul>
            </div>
            <button className="pricing-button">Buy</button>
          </div>

          {/* Annual Reassessment Card */}
          <div className="pricing-card">
            <div className="pricing-header">
              <h2>Annual Reassessment</h2>
              <h3>(uses your initial DNA/SNPs data)</h3>
            </div>
            <div className="pricing-price">
              <span className="currency">$</span>
              <span className="amount">699</span>
              <span className="period">Annually</span>
            </div>
            <div className="pricing-features">
              <h4>Includes</h4>
              <ul>
                <li>Calibrated Biometric Questionnaire</li>
                <li>Revised Emotional State Report</li>
              </ul>
            </div>
            <button className="pricing-button">Buy</button>
          </div>
        </div>

        <div className="pricing-info">
          <div className="info-section">
            <h3>Delivery Information</h3>
            <p>
              Results Report delivery time is expected to be approximately 2-3
              weeks (depending on courier/post and lab processing times)
            </p>
            <p>Assessment fees are non-refundable.</p>
          </div>
        </div>
      </div>
    </SharedLayout>
  );
};

export default PricingView;
